import {isAbsoluteUrl} from './is-absolute-url';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

const APP_ORIGINS = getAppOrigins();

export function normalizeStorageUrl(path?: string | null): string {
  if (!path) return '';
  const storageUrl = getStorageUrl();
  if (!storageUrl) {
    return path;
  }

  const relativePath = getStorageRelativePath(path);
  if (!relativePath) {
    return path;
  }

  return `${storageUrl}/${relativePath}`;
}

function getStorageUrl(): string {
  return (
    import.meta.env.VITE_STORAGE_URL ||
    getBootstrapData()?.settings?.storage_url ||
    ''
  ).replace(/\/+$/, '');
}

function getStorageRelativePath(path: string): string | null {
  const relativeMatch = path.match(/^\/?storage\/(.+)$/);
  if (relativeMatch) {
    return relativeMatch[1].replace(/^\/+/, '');
  }

  if (!isAbsoluteUrl(path) && !path.startsWith('//')) {
    return null;
  }

  try {
    const url = path.startsWith('//')
      ? new URL(`https:${path}`)
      : new URL(path);

    const absoluteMatch = url.pathname.match(/^\/storage\/(.+)$/);
    if (!absoluteMatch || !shouldRewriteAbsoluteUrl(url)) {
      return null;
    }

    return `${absoluteMatch[1].replace(/^\/+/, '')}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

function shouldRewriteAbsoluteUrl(url: URL): boolean {
  if (!APP_ORIGINS.size) {
    return true;
  }

  return APP_ORIGINS.has(url.origin);
}

function getAppOrigins(): Set<string> {
  const origins = new Set<string>();

  [
    import.meta.env.VITE_ASSET_URL,
    import.meta.env.VITE_API_URL,
    typeof window !== 'undefined' ? window.location.origin : undefined,
  ].forEach(value => {
    if (!value) return;

    try {
      origins.add(new URL(value).origin);
    } catch {
      // Ignore malformed env values.
    }
  });

  return origins;
}
